import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'shared/components/Link';
import { bindActionCreators } from 'redux';
import * as advertActions from 'shared/actions/advertForm';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { numberWithSpaces } from 'shared/helpers/common';
import { partsFormActions, partsFormAsyncSetActions } from 'shared/actions/partsForm';
import {
  injectTopMakesToOptions,
  skipTopMakes,
} from 'shared/components/SearchPanel/transformOptions';
import history from 'history.js';
import Select from 'react-select';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import UpdatedSelect from '../UpdatedSelect/UpdatedSelect';
import s from './CarEstimatePanel.css';

class CarEstimatePanel extends React.Component {
  static propTypes = {
    years: PropTypes.arrayOf(PropTypes.number),
    makes: PropTypes.arrayOf(PropTypes.shape()),
    models: PropTypes.arrayOf(PropTypes.shape()),
    setPartsActions: PropTypes.shape().isRequired,
    setAdvertActions: PropTypes.shape().isRequired,
    advertsAveragePrice: PropTypes.arrayOf(PropTypes.shape()),
    isHome: PropTypes.bool,
    averagePriceParams: PropTypes.shape(),
    averagePrice: PropTypes.arrayOf(PropTypes.shape()),
    showAveragePrice: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    years: [],
    makes: [],
    models: [],
    averagePrice: undefined,
    isHome: false,
    averagePriceParams: null,
    advertsAveragePrice: null,
    showAveragePrice: false,
  };

  state = {
    make: null,
    model: null,
    mileage: '',
    year: '',
  };

  componentDidMount = () => {
    if (this.props.averagePriceParams && !this.state.make) {
      this.setState({ ...this.props.averagePriceParams });
      this.props.setAdvertActions.showAveragePrice(true);
    }
  };

  componentWillUpdate = nextProps => {
    if (!this.state.make && nextProps.averagePriceParams) {
      this.setState({ ...nextProps.averagePriceParams });
      this.props.setAdvertActions.showAveragePrice(true);
    }
  };

  componentWillUnmount = () => {
    const { isHome, setAdvertActions } = this.props;
    if (!isHome) {
      setAdvertActions.averagePriceParams(null);
      setAdvertActions.advertsAveragePrice(null);
      setAdvertActions.dataAveragePrice(undefined);
    }
  };

  getAveragePrice = () => {
    const { isHome, setAdvertActions } = this.props;

    setAdvertActions.averagePrice(this.state);
    if (isHome) history.push('/service/ocenka-avto/');
  };

  handleMakeChange = val => {
    const { setPartsActions, setAdvertActions, isHome } = this.props;

    setAdvertActions.averagePriceParams(null);
    setAdvertActions.showAveragePrice(false);

    if (!isHome) setAdvertActions.dataAveragePrice(undefined);
    this.setState({
      make: val,
      model: null,
      mileage: '',
      year: '',
    });

    setPartsActions.make(val);
    setAdvertActions.make(val);
  };

  handleInputChange = (name, val) => {
    const { isHome, setAdvertActions, averagePrice } = this.props;
    const { year } = this.state;

    if (name === 'model' && year) this.setState({ year: '' });
    if (!isHome && averagePrice) setAdvertActions.dataAveragePrice(undefined);

    setAdvertActions[name](val);
    this.setState({ [name]: val });
    setAdvertActions.showAveragePrice(false);
  };

  render() {
    const {
      years: yearsStore,
      makes,
      models,
      isHome,
      intl,
      averagePrice,
      averagePriceParams,
      advertsAveragePrice,
      showAveragePrice,
    } = this.props;
    const years = yearsStore.sort((a, b) => b - a);

    const { make, model, year, mileage } = this.state;
    const makesWithTopMakes = injectTopMakesToOptions(makes, intl);

    let ukAveragePrice = null;

    if (averagePrice) {
      const usdData = averagePrice.filter(item => item.currency === 'uah');
      ukAveragePrice = usdData.length && numberWithSpaces((+usdData[0].value).toFixed());
    } else if (advertsAveragePrice && advertsAveragePrice.length) {
      let sumCurrencies = 0;
      advertsAveragePrice.map(item => {
        sumCurrencies += item.price.filter(data => data.currency === 'uah')[0].value;
      });
      ukAveragePrice = numberWithSpaces(sumCurrencies / advertsAveragePrice.length);
    }

    const disabledBtn = !make || !model || !year;
    const showEmptyMessage =
      showAveragePrice &&
      !ukAveragePrice &&
      advertsAveragePrice &&
      advertsAveragePrice.length === 0;

    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makesWithTopMakes}
              labelKey="title"
              valueKey="id"
              onChange={this.handleMakeChange}
              value={make}
              filterOption={skipTopMakes}
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length || !make}
              options={models || []}
              onChange={val => this.handleInputChange('model', val)}
              value={model}
              matchPos="start"
            />
          </div>
          <div className={cx(s.filterItem, s.twiceItem)}>
            <UpdatedSelect
              instanceId="year-ff"
              name="year"
              placeholder={intl.formatMessage({ id: 'Год' })}
              labelKey="value"
              valueKey="id"
              disabled={!years.length}
              options={years.map(item => ({ id: item, value: item })) || []}
              onChange={val => this.handleInputChange('year', val && val.value)}
              value={year}
            />
            <RegexpInput
              className={cx(s.input, s.to, { [s.hideBorder]: isHome })}
              type="text"
              placeholder={intl.formatMessage({ id: 'Пробег, тыс. км' })}
              value={mileage}
              onChange={val => this.handleInputChange('mileage', val)}
              pattern={'^[0-9]+$'}
            />
          </div>
        </div>
        {!isHome && ukAveragePrice && averagePriceParams && showAveragePrice ? (
          <div className={s.priceBlock}>
            <div className={s.averagePriceTitle}>
              <FormattedMessage id="Средняя цена" /> {make && make.title} {model && model.title}{' '}
              {year} {intl.formatMessage({ id: 'года' })}
            </div>
            <div className={s.price}> {ukAveragePrice} грн</div>
          </div>
        ) : (
          <div className={s.buttonContainer}>
            <div className={s.buttonBlock}>
              <Link
                className={cx(s.button, { [s.disabledBtn]: disabledBtn })}
                onClick={this.getAveragePrice}
                disabled={disabledBtn}
                data-lens-event={'rateMyCarClick'}
              >
                {intl.formatMessage({ id: 'Оценить мой автомобиль' })}
              </Link>
            </div>
          </div>
        )}
        {showEmptyMessage && (
          <div className={s.emptyInfoMessage}>
            <FormattedMessage id="К сожалению, у нас недостаточно данных, чтобы оценить ваш автомобиль" />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ partsForm, advertForm, homeCounters }) => ({
  years: advertForm.data.years || [],
  makes: homeCounters && homeCounters.all,
  models: partsForm.vocabulary.models,
  averagePrice: advertForm.data.averagePrice,
  averagePriceParams: advertForm.data.averagePriceParams,
  advertsAveragePrice: advertForm.data.advertsAveragePrice,
  showAveragePrice: advertForm.data.showAveragePrice,
});

const mapDispatchToProps = dispatch => ({
  setPartsActions: bindActionCreators(
    {
      ...partsFormActions.partsForm.selected.set,
      ...partsFormAsyncSetActions,
    },
    dispatch,
  ),
  setAdvertActions: bindActionCreators(
    {
      ...advertActions.selectedActions.set,
      ...advertActions.carSetThunks,
      averagePriceParams: advertActions.setData.averagePriceParams,
      advertsAveragePrice: advertActions.setData.advertsAveragePrice,
      dataAveragePrice: advertActions.setData.averagePrice,
      showAveragePrice: advertActions.setData.showAveragePrice,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(s)(injectIntl(CarEstimatePanel)));



// WEBPACK FOOTER //
// ./src/desktop/components/CarEstimatePanel/CarEstimatePanel.js